import { baseQuery } from '../baseQuery';

type PutTechnicianPayload = {
  noteId: number;
  notes: string;
  note_type: number;
};

export const putTechnicianNote = async (payload: PutTechnicianPayload) => {
  const { noteId, ...rest } = payload;
  const { data } = await baseQuery(`technicians/notes/${noteId}`, {
    type: 'PUT',
    body: {
      ...rest,
    },
  });

  return data;
};
